const transitionDuration = {
  name: "transition-duration",
  path: "/transition-duration",
  title: "transition-duration",
  description: "Utilities for controlling the duration of transitions.",
  value: {
    'transition-duration': {
      'duration-initial': 'initial',
      'duration-<number>': '<number>ms'
    },
  },
  exampleData: [
    {
      example: {
        code: `<button class="transition-all duration-500 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
  500ms Transition
</button>
<button class="transition-all duration-initial bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded mt-4">
  Initial Duration
</button>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">duration-&#60;number&#62;</code> to set the transition duration in milliseconds, or <code class="text-color-gray-800 dark:text-color-white font-semibold">duration-initial</code> for the initial value.
      </p>
      <div class="flex gap-4">
        <div>
          <button class="transition-all hover:scale-125 duration-500 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
            500ms Transition
          </button>
        </div>
        <div>
          <button class="transition-all hover:scale-125 duration-1000 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
            1000ms Transition
          </button>
        </div>
        <div>
          <button class="transition-all hover:scale-125 duration-initial bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
            Initial Duration
          </button>
        </div>
      </div>
      `
    }
  ]
};

export default transitionDuration;
<div className="sr-only duration-500 duration-initial duration-1000 hover:scale-125"></div>